// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { Header } from './../../../../components/layout/Header';
import Grid, { GridItem } from './../../../../components/layout/Grid';
import {
  Cell as ListCell,
  Row as ListRow } from
'./../../../../components/ui/ListTable';
import Popover from './../../../../components/ui/Popover';

/**
 * Элементы используемые в табличках в Регламенте и закреплениях
 */
export const ListHeader = styled(Grid).withConfig({ displayName: "elements__ListHeader", componentId: "sc-19mssxf-0" })(["background:#e4ebf2;border-radius:2px 2px 0px 0px;"]);



export const HeaderCell = styled.div.withConfig({ displayName: "elements__HeaderCell", componentId: "sc-19mssxf-1" })(["padding:8px 16px;color:#838d96;font-size:12px;"]);




export const HeaderBoldCell = styled(HeaderCell).withConfig({ displayName: "elements__HeaderBoldCell", componentId: "sc-19mssxf-2" })(["font-weight:500;color:#3d4042;font-size:14px;"]);




export const Row = styled(ListRow).withConfig({ displayName: "elements__Row", componentId: "sc-19mssxf-3" })(["padding:0;border-bottom:1px solid #e4ebf2;"]);



export const Cell = styled(ListCell).withConfig({ displayName: "elements__Cell", componentId: "sc-19mssxf-4" })(["display:flex;align-items:center;width:100%;padding:8px 16px;min-height:45px;box-sizing:border-box;"]);







export const VehicleInfo = styled.div.withConfig({ displayName: "elements__VehicleInfo", componentId: "sc-19mssxf-5" })(["line-height:1.5;& p{margin-bottom:5px;}"]);





export const Bold = styled.b.withConfig({ displayName: "elements__Bold", componentId: "sc-19mssxf-6" })(["font-weight:500;"]);


export const Day = styled(({ isWeekend, children, ...props }) =>
isWeekend ?
<Popover content="Выходной день">
      <span {...props}> ({children})</span>
    </Popover> :

<span {...props}> ({children})</span>

).withConfig({ displayName: "elements__Day", componentId: "sc-19mssxf-7" })(["", ";text-transform:capitalize;"],
({ isWeekend }) =>
isWeekend &&
css(["color:red;cursor:help;"]));






export const FilterButtons = styled(GridItem).withConfig({ displayName: "elements__FilterButtons", componentId: "sc-19mssxf-8" })(["display:flex;align-items:center;"]);




export const ActionsHeader = styled(Header).withConfig({ displayName: "elements__ActionsHeader", componentId: "sc-19mssxf-9" })(["background:#f0f4f8;"]);
